import { useContext, useEffect, useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Flex,
  Button,
  Tab,
  TabPanel,
  TabIndicator,
} from "@chakra-ui/react";
import MtDocumentTable from "../MtDocumentTable";
import { AppContext } from "AppProvider/AppContext";
import { RiFileExcel2Fill } from "react-icons/ri";
import { exportAllExcel } from "../common/PRYViewer/component/utils/functions";
import { appRequest } from "routes";
import { Paginationlimit } from "components/common/functions/variable";
import DownloadMtExcelComponent from "../DownloadMtExcelComponent";

export default function MtApprovals(): JSX.Element {
  const { accountDetails, workFlowData, startDate, endDate, selectedTransport } = useContext(AppContext);
  const { toastNotify } = useContext(AppContext);
  const isExceptionUser = accountDetails?.designation === "exception User";

  const [selectedTab, setSelectedTab] = useState(() => {
    if (isExceptionUser) return 0;
    const stored = sessionStorage.getItem('documentTab');
    return stored ? Number(stored) : 0;
  });

  const [dateFrom, setFromDate] = useState(() => {
    const dateRange = workFlowData?.dateFilter?.range;
    const rangeActive = workFlowData?.dateFilter?.rangeActive;
    const today = new Date();
    if (rangeActive && dateRange) {
      const endMonth = parseInt(dateRange.split("-")[1], 10);
      today.setMonth(today.getMonth() - endMonth);
    } else {
      today.setMonth(today.getMonth() - 6);
    }
    return today;
  });

  const [dateTo, setToDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate());
    return tomorrow;
  });


  const handleChange = (index: number) => {
    setSelectedTab(index);
    if (!isExceptionUser) {
      sessionStorage.setItem("documentTab", String(index));
    }
  };

  const tabStyles = {
    _hover: { color: "teal.600", bg: "teal.50", borderRadius: "md" },
    _selected: { color: "teal.600" },
    _active: { bg: "teal.100" },
    fontWeight: "700",
    fontSize: { base: "0.9rem", md: "1.1rem" },
    cursor: "pointer",
    color: "teal.400",
    px: "1.2rem",
    py: "0.8rem",
    transition: "all 0.3s ease",
  };

  return (
    <Tabs
      variant="unstyled"
      position="relative"
      onChange={handleChange}
      index={selectedTab}
    >
      <Flex align="center" justify="space-between">
        <TabList>
          {isExceptionUser ? (
            <Tab {...tabStyles}>Exception</Tab>
          ) : (
            <>
              <Tab {...tabStyles}>Pending</Tab>
              {workFlowData?.levels > 1 && (
                <Tab {...tabStyles}>
                  {accountDetails?.role === "uploader" ? "Uploaded" : "Approved"}
                </Tab>
              )}
              <Tab {...tabStyles}>Posted</Tab>
              <Tab {...tabStyles}>Exception</Tab>
              <Tab {...tabStyles}>Guest House</Tab>
              <Tab {...tabStyles}>Payment Failed</Tab>
              <Tab {...tabStyles}>Undefined Document</Tab>
            </>
          )}
        </TabList>

        {workFlowData?.processName === "mmt" && (
          <DownloadMtExcelComponent
            ml="auto"
            dateFilterKey="Invoice_Date"
            processName={workFlowData?.processName}
            processType={workFlowData?.processType}
            transportType={selectedTransport}
            variant="outline"
            colorScheme="teal"
          // rightIcon={<RiFileExcel2Fill color="teal" />}
          >
            Export All
          </DownloadMtExcelComponent>
        )}
      </Flex>
      <TabIndicator mt="-2px" height="3px" bg="teal.500" borderRadius="3px" transition="all 0.3s ease !important" />
      <TabPanels>
        {isExceptionUser ? (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            <MtDocumentTable
              name="Pending Approval"
              type="pending"
              activePage={"Exception"}
              isDisabled={true}
              statusType="exception"
              isManual={true}
            />
          </TabPanel>
        ) : (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === 0 && (
              <MtDocumentTable
                name="Pending Approval"
                type="pending"
                activePage={"Pending Approval"}
                isDisabled={false}
                isManual={false}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && workFlowData?.levels > 1 && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === 1 && (
              <MtDocumentTable
                name="Approved"
                type="approved"
                activePage={"Approved"}
                isDisabled={true}
                isManual={false}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === (workFlowData?.levels > 1 ? 2 : 1) && (
              <MtDocumentTable
                name="Posted"
                type="approved"
                activePage={"pending"}
                isDisabled={true}
                isManual={false}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === (workFlowData?.levels > 1 ? 3 : 2) && (
              <MtDocumentTable
                name="Pending Approval"
                type="pending"
                activePage={"Exception"}
                isDisabled={true}
                statusType="exception"
                isManual={true}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === (workFlowData?.levels > 1 ? 4 : 3) && (
              <MtDocumentTable
                name="Guest House"
                type="pending"
                activePage={"Guest House"}
                isDisabled={true}
                statusType="guestHouse"
                isManual={false}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === (workFlowData?.levels > 1 ? 5 : 4) && (
              <MtDocumentTable
                name="Payment Failed"
                type="pending"
                activePage={"Payment Failed"}
                isDisabled={true}
                statusType="paymentFailed"
                isManual={false}
              />
            )}
          </TabPanel>
        )}

        {!isExceptionUser && (
          <TabPanel
            pr={{ base: "0rem !important", lg: "unset" }}
            pl={{ base: "0rem !important", lg: "1rem !important" }}
          >
            {selectedTab === (workFlowData?.levels > 1 ? 6 : 5) && (
              <MtDocumentTable
                name="Undefined Document"
                type="pending"
                activePage={"Undefined Document"}
                statusType="undefined"
                isDisabled={true}
                isManual={false}
              />
            )}
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
}